import { render } from "./SiteBanner.vue?vue&type=template&id=56348340"
import script from "./SiteBanner.vue?vue&type=script&lang=js"
export * from "./SiteBanner.vue?vue&type=script&lang=js"

import "./SiteBanner.vue?vue&type=style&index=0&id=56348340&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__